import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

function BackButton({
  to,
  children = "Back",
  className = "",
  useHistory = false,
}) {
  const navigate = useNavigate();

  if (useHistory) {
    return (
      <button
        onClick={() => navigate(-1)}
        className={`text-primary-500 hover:text-primary-700 mb-4 inline-flex items-center space-x-2 ${className}`}
      >
        <ArrowLeftIcon className="w-4 h-4" />
        <span>{children}</span>
      </button>
    );
  }

  return (
    <Link
      to={to}
      className={`text-primary-500 hover:text-primary-700 mb-4 inline-flex items-center space-x-2 ${className}`}
    >
      <ArrowLeftIcon className="w-4 h-4" />
      <span>{children}</span>
    </Link>
  );
}

export default BackButton;
